<template>
<td :class="classes">
  <component
    @itemDelete="itemDelete"
    :params="params"
    :is="subComponent"
    :model="model"
    :item="item"
    :column="column"
    :duplicateDescriptionText="$t('models.duplicate_desc')"
  />
</td>
</template>
<script>
import CollectionValueShow from "./CollectionValues/CollectionValueShow"
import CollectionValueShowWithLink from "./CollectionValues/CollectionValueShowWithLink"
import CollectionValueShowWithEditLink from "./CollectionValues/CollectionValueShowWithEditLink"
import CollectionValueCrudAction from "./CollectionValues/CollectionValueCrudAction"
import CollectionValueCrudActionFolded from "./CollectionValues/CollectionValueCrudActionFolded"
import CollectionValueShowAction from "./CollectionValues/CollectionValueShowAction"
import CollectionValueEditAction from "./CollectionValues/CollectionValueEditAction"
import CollectionValueDeleteAction from "./CollectionValues/CollectionValueDeleteAction"
import CollectionValueStatus from "./CollectionValues/CollectionValueStatus"
import CollectionValueLeadName from "./CollectionValues/CollectionValueLeadName"
import CollectionValuePeriod from "./CollectionValues/CollectionValuePeriod"
import CollectionValueClassification from "./CollectionValues/CollectionValueClassification"
import CollectionValueProgress from "./CollectionValues/CollectionValueProgress"
import CollectionValueDate from "./CollectionValues/CollectionValueDate"
import CollectionValueUnassign from "./CollectionValues/CollectionValueUnassign"
import CollectionValueProjectName from "./CollectionValues/CollectionValueProjectName"
import CollectionValueUnsyncedCount from "./CollectionValues/CollectionValueUnsyncedCount"
import CollectionValueCrmStatus from "./CollectionValues/CollectionValueCrmStatus"
import CollectionValueOrigin from "./CollectionValues/CollectionValueOrigin"
import CollectionValueImportOrigin from "./CollectionValues/CollectionValueImportOrigin"
import CollectionValueCompany from "./CollectionValues/CollectionValueCompany"
import CollectionValueActionDuplicate from "./CollectionValues/CollectionValueActionDuplicate"
import CollectionValueProjectLink from "./CollectionValues/CollectionValueProjectLink"
import CollectionValueValidEmail from "./CollectionValues/CollectionValueValidEmail"
import CollectionValueFullname from "./CollectionValues/CollectionValueFullname"
import CollectionValueFormSlug from "./CollectionValues/CollectionValueFormSlug"

export default {
  props: ['item', 'column', 'model', 'params'],
  components: {
    CollectionValueShow,
    CollectionValueShowWithLink,
    CollectionValueShowWithEditLink,
    CollectionValueShowAction,
    CollectionValueCrudAction,
    CollectionValueCrudActionFolded,
    CollectionValueEditAction,
    CollectionValueDeleteAction,
    CollectionValueStatus,
    CollectionValueLeadName,
    CollectionValuePeriod,
    CollectionValueClassification,
    CollectionValueProgress,
    CollectionValueDate,
    CollectionValueUnassign,
    CollectionValueProjectName,
    CollectionValueUnsyncedCount,
    CollectionValueCrmStatus,
    CollectionValueOrigin,
    CollectionValueImportOrigin,
    CollectionValueCompany,
    CollectionValueActionDuplicate,
    CollectionValueProjectLink,
    CollectionValueValidEmail,
    CollectionValueFullname,
    CollectionValueFormSlug
  },
  methods: {
    itemDelete(item){
      this.$emit('itemDelete', item)
    }
  },
  computed: {
    classes(){
      return ['value', this.model + '-' + this.column.name]
    },
    subComponent(){
      let type = this.column.type === undefined ? "Show" : _.upperFirst(_.camelCase(this.column.type))
      return _.kebabCase(`CollectionValue ` + type)
    }
  }
}
</script>
<style lang="scss">
.collection{
  .table{
    table-layout: auto;
  }
}
</style>



// WEBPACK FOOTER //
// CollectionValue.vue?b3c2002a